import ApiRequestManagerInstance from '../ApiRequestManager';
import Slider from '../../classes/slider';
import TranslationManager from '../../assets/locale/translationsManager';
import { store } from '../../store/store';
import { ISliderRequest } from '../../types/interfaces/slider';
import ImageUtils from '@shared/utils/image';

function slidersRequest(section = '') {
  const promise = new Promise<Slider[]>(async (resolve) => {
    try {
      const { user } = store.getState();
      const response: ISliderRequest = (await ApiRequestManagerInstance.get({
        endpoint: {
          url: 'cdnSyncUrl',
          section: 'media',
          subsection: 'carrier',
          type: (user.isAnonymous ? 'slidersAnonymous' : 'sliders') + section,
          params: '.' + TranslationManager.currentLanguage + '.json',
        },
      })) as ISliderRequest;

      let sliders: Slider[] = [];
      if (response.data?.length) {
        const { channels } = store.getState();
        sliders = response.data
          .filter((slider) => {
            return (
              (!slider.channelName && !slider.relatedMedia) ||
              channels.favouriteChannels?.find((ch) => {
                return (
                  slider.relatedMedia?.channel === ch.id ||
                  slider?.channelName === ch.name
                );
              })
            );
          })
          .filter((slider) => {
            return !slider.isCpg && !slider.app;
          })
          .sort((slider1, slider2) => {
            return (slider1.order || 0) > (slider2.order || 0) ? 1 : -1;
          })
          .map((item, index) => {
            return new Slider(item, index);
          });
      }
      for (const slider of sliders) {
        if (slider.type === 'image_ads') {
          await slider.imageAds();
          await slider.extendedImageAds()
        }
      }
      resolve(sliders);
    } catch (e) {
      resolve([]);
    }
  });

  return promise;
}

export default slidersRequest;
